/*eslint-disable */

import {
  bus
} from '@/main';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'update-group-name',
  components: {},
  props: ['updateGroupNameID'],
  data () {
    return {
      submitted:false,
      topic:'',
    }
  },
  computed: {

  },
  mounted () {
    document.body.classList.add('body_right_scroll_remove');
    this.getGroupInfoByIdMethod(false);
  },
  methods: {
    getGroupInfoByIdMethod(isMounted){
      this.$store.dispatch('getGroupChatDetailsByIdFun', { id: this.updateGroupNameID }).then((res)=>{
        this.topic = res.data.data.name;
        if(isMounted){
         bus.$emit('updateGroupInfoDataBus', res.data.data);
        }
      })
    },
    getChatRoomListMethod(){
       this.$store.dispatch('getAllLeftChatListDetailsFun');
    },
    updateGroupChatBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true;
          var data = {
            name:this.topic,
          }
          this.$store.dispatch('updateGroupChatDetailsFun', {data:{data:data,id:this.updateGroupNameID}})
            .then((res) => { 
              toast.success(res.data.msg);
              this.getGroupInfoByIdMethod(true);
              // this.getChatRoomListMethod();
              this.updateGroupPopupClosedMethod();
              this.submitted =  false;
            }).catch((err) => {
              toast.error(err.data.msg);
              this.submitted =  false
            })
          return;
        }
      })
    },
    updateGroupPopupClosedMethod(){
      document.body.classList.remove('body_right_scroll_remove');
      bus.$emit('updateGroupNamePopupStateBus', false);
    }
  },
  watch:{
  }
}